import styled from 'styled-components'

export const Container = styled.div`
  width: auto;
`

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: ${({ numCards }) => `repeat(${numCards > 1 ? 2 : 1}, 380px)`};
  margin-bottom: 10px;
  gap: 15px;
`

export const InfoText = styled.p`
  color: #000000;
  font-size: 16px;
  text-align: center;
`

export const Title = styled(InfoText)`
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
`

export const SubTitle = styled(Title)`
  font-size: 14px;
  margin-bottom: 7px;
`
